<!--多选 MCQ-->
<template>
  <div class="question-editor">
    <div class="question-pd">
      <!-- <div class="question-header"></div> -->
      <div class="question-header">
        <div class="question-header-left">
          <div class="question-header-left">
            <span v-if="isMust" class="asterisk">*</span>
            <span class="question-number">{{
              `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
            }}</span>
            <div class="question-select">
              <span>多选</span>
            </div>
          </div>
          <div class="question-header-right">
            <div class="add-batch" @click="handleShowCount">
              <span v-if="isCountMust">必须选{{ maxCount }}项</span>
              <span v-else-if="isCountSwitch"
                >最多{{ maxCount }}项，最少{{ minCount }}项</span
              >
              <span v-else>最多{{ maxCount }}项</span>
              <!-- <div class="icon"></div> -->
            </div>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
        :style="{
          border:
            isFocusIndex === '-1'
              ? '1px solid rgba(58,96,255,0.5)'
              : '1px solid #DCDDE0',
        }"
      >
        <textarea
          
          v-model="caseProblem"
          placeholder="请选择一个选项"
          maxlength="500"
          auto-height
          @input="handleUpdate"
          @focus="isFocusIndex = '-1'"
          @blur="isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          />
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
      <div class="question-images">
        <div
          v-for="(item, idx) in images"
          :key="idx"
          style="position: relative"
        >
          <img :src="item" style="width: 100%" />
          <img
            src="@/assets/images/guanbi.png"
            class="guanbi"
            @click="handleDeleteQuestionImage(idx)"
          />
        </div>
      </div>
      <div class="options">
        <div v-for="(option, index) in list" :key="index">
          <div class="option-item">
            <div class="option-item-top">
              <div class="option-item-top-left">
                <img
                  v-if="list.length > 2"
				  @click="delItem(index)"
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-red.svg"
                />
                <img
                  v-else
                  class="del1"
                  src="https://ossfytp.mustke.com/image/newStyleImages/del-gray.svg"
                />
              </div>
              <div
                class="option-item-top-right"
                :style="{
                  border:
                    inputFocusIndex === `a${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <div class="option-item-top-right-up">
                  <input
                    type="text"
                    :placeholder="'选项' + (index + 1)"
                    v-model="option.text"
                    @focus="inputFocusIndex = `a${index}`"
                    @blur="inputFocusIndex = ''"
                  />
                  <div class="option-item-top-right-right">
                    <img
                      src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
                      style="
                        width: 18px;
                        height: 18px;
                        margin-right: 6px;
                        cursor: pointer;
                      "
                      @click="handleItemImage(index)"
                    />
                    <el-checkbox v-model="option.is_fill" @change="handleUpdate"
                      >填空</el-checkbox
                    >
                  </div>
                </div>

                <div class="question-images">
                  <div
                    class="question-images-box"
                    v-for="(imgItem, imgIndex) in option.img_path"
                    :key="imgIndex"
                    style="
                      margin-top: 10px;
                      position: relative;
                      margin-bottom: 5px;
                    "
                  >
                    <img :src="imgItem" class="thumbnail-image" />
                    <div class="fangda-box">查看图片</div>
                    <img
                      src="@/assets/images/guanbi.png"
                      class="guanbi"
                      @click="handleDeleteItemImage(index, imgIndex)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="option.is_fill" class="option-item-bottom">
              <div
                class="option-item-bottom-input"
                :style="{
                  border:
                    inputFocusIndex === `b${index}`
                      ? '1px solid rgba(58,96,255,0.5)'
                      : '1px solid #DCDDE0',
                }"
              >
                <input
                  type="text"
                  placeholder="编辑提示词"
                  v-model="option.fill_prompt"
                  @focus="inputFocusIndex = `b${index}`"
                  @blur="inputFocusIndex = ''"
                  @change="handleUpdate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fangda-popup" v-if="fangdaShow" @click="fangdaClose">
        <div class="popup-content" @click.stop>
          <img
            src="@/assets/images/guanbi.png"
            class="popup-guanbi"
            @click="fangdaClose"
          />
          <div class="popup-scroll">
            <div>{{ fangdaTitle }}</div>
            <img :src="fangdaImgUrl" style="width: 100%" />
          </div>
        </div>
      </div>
      <div class="add-view">
        <div class="required">
          <el-checkbox v-model="isMust">必选题</el-checkbox>
        </div>
        <div @click="addOption" class="add-btn">
          <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737858857723.png"
            style="width: 12px; height: 12px"
          />
          <span>添加选项 {{ list.length + "/50" }}</span>
        </div>
        <div @click="batchAddOptions" class="add-batch">批量添加</div>
      </div>
    </div>
    <div class="option-settings">
      <div class="question-header-right">
        <div class="add-batch" @click="handleShowScore">
          <span>设置分值 {{ totalScore }}分</span>
        </div>
      </div>
      <el-checkbox v-model="ifRandomize" @change="handleUpdate"
        >选项随机排列</el-checkbox
      >
    </div>
    <div class="question-footer">
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
    <PopupInput
      :showDialog="showpopup"
      :title="'批量添加'"
      :aContent="''"
      :type="1"
      @close="showpopup = false"
      @confirm="bitchConfirm"
    ></PopupInput>
    <!-- <uploadImage
      :show="(showUploadad = false)"
      @upload-success="handleUploadComplete"
    /> -->
    <!-- <MultipleChoiceCount
      :show="showCount"
      :totalCount="list.length"
      :maxCount="maxCount"
      :minCount="minCount"
      :isCountMust="isCountMust"
      :isCountSwitch="isCountSwitch"
      @close="showCount = false"
      @confirm="handleCountConfirm"
    /> -->
    <div class="coverShow" v-if="showCount">
      <div class="container-gj">
        <div class="container-gd">
          <div class="header-div">
            <div
              style="
                font-size: 18px;
                font-weight: 600;
                color: #2b2f36;
                line-height: 24px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
              "
            >
              选择设置
            </div>
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1736759941513.png"
              mode=""
              @click="showCount = false"
              style="
                width: 13px;
                height: 13px;
                position: absolute;
                right: 20px;
                cursor: pointer;
              "
            />
          </div>
          <div
            v-if="!isCountMust && !isCountSwitch"
            style="
              display: flex;
              justify-content: flex-start;
              padding: 0 15px;
              box-sizing: border-box;
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #e5e5e5;
            "
          >
            <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
            <span style="font-size: 14px; color: #a7adc6"
              >最多选{{ maxCount }}项</span
            >
          </div>
          <div
            v-if="isCountMust"
            style="
              display: flex;
              justify-content: flex-start;
              padding: 0 15px;
              box-sizing: border-box;
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #e5e5e5;
            "
          >
            <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
            <span style="font-size: 14px; color: #a7adc6"
              >必须选{{ maxCount }}项</span
            >
          </div>
          <div
            v-if="isCountSwitch"
            style="
              display: flex;
              justify-content: flex-start;
              padding: 0 15px;
              box-sizing: border-box;
              height: 40px;
              line-height: 40px;
              border-bottom: 1px solid #e5e5e5;
            "
          >
            <!-- <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
            <span style="font-size: 14px; color: #a7adc6"
              >最少选{{ minCount }}项</span
            > -->
            <span style="font-size: 14px; color: #a7adc6">当前设置:</span>
            <span style="font-size: 14px; color: #a7adc6"
              >最多选{{ maxCount }}项，</span
            >
            <span style="font-size: 14px; color: #a7adc6"
              >最少选{{ minCount }}项</span
            >
          </div>
          <div class="count-item">
            <div style="display: flex; align-items: center">
              <div style="font-size: 14px">最多选</div>
              <el-input-number
                v-model="maxCount"
                :min="1"
                :max="list.length"
                style="margin-left: 10px"
                @blur="handleMaxCountBlur"
              ></el-input-number>
              <div style="margin-left: 10px; font-size: 14px">项</div>
            </div>
            <el-checkbox
              label="必选题"
              v-model="isCountMust"
              :true-label="1"
              :false-label="0"
              class="custom-checkbox"
              @change="handleCountMustChange"
            ></el-checkbox>
          </div>
          <div class="count-item">
            <div style="display: flex; align-items: center">
              <div style="font-size: 14px">最少选</div>
              <el-input-number
                v-model="minCount"
                :min="1"
                :max="maxCount"
                style="margin-left: 10px"
                @blur="handleMinCountBlur"
              ></el-input-number>
              <div style="margin-left: 10px; font-size: 14px">项</div>
            </div>
            <el-switch
              v-model="isCountSwitch"
              active-color="#13ce66"
              inactive-color="#EDEDED"
              :active-value="1"
              :inactive-value="0"
              @change="handleCountSwitchChange"
            >
            </el-switch>
          </div>
          <div style="width: 100%; display: flex; justify-content: center">
            <el-button
              type="primary"
              @click="handleCountConfirm"
              style="width: 120px; margin: 20px auto"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showScore" title="分值设置" width="500px">
      <div class="score-dialog-body">
        <div v-for="(item, index) in scoreList" :key="index" class="score-item">
          <span class="score-text">{{ item.text }}</span>
          <!-- <Stepper
            :initialValue="item.score"
            :decimalDigits="1"
            :step="0.5"
            :minValue="0"
            :maxValue="1000"
            @update="handleStepperUpdate($event, index)"
            :key="index"
          /> -->
          <el-input-number
            v-model="item.score"
            :precision="1"
            :step="0.5"
            :min="0"
            :max="1000"
            @change="handleStepperUpdate($event, index)"
            size="mini"
          ></el-input-number>
        </div>
      </div>
      <div v-if="type === 1" class="question-footer">
        <div class="save-btn" @click.stop="confirmClick">保存</div>
      </div>
    </el-dialog>
    <input
      type="file"
      ref="fileInput"
      accept="image/*"
      style="display: none"
      @change="handleFileChange"
    />
  </div>
</template>

<script>
// import Stepper from "@/components/Stepper/Stepper.vue";
import PopupInput from "@/components/PopupInput/PopupInput.vue";
import axios from "axios";
import baseURL from "../../utils/bsaeUrl";
export default {
  name: "EvaluationEditMCQ",
  components: {
    // Stepper,
    PopupInput,
    // uploadImage: () => import("@/components/uploadImage/uploadImage.vue"),
    // MultipleChoiceCount: () =>
    // import("@/components/MultipleChoiceCount/MultipleChoiceCount.vue"),
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    isPage: {
      type: Number,
      default: 0,
    },
    ifRandomOrder: {
      type: String,
      default: "0",
    },
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      list: [],
      ifRandomize: false,
      isMust: false,
      images: [],
      showpopup: false,
      showUpload: false,
      uploadIndex: -1,
      caseProblem: "",
      count: 0,
      showCount: false,
      maxCount: 1,
      minCount: 1,
      isFocusIndex: "",
      inputFocusIndex: "",
      isCountMust: false,
      isCountSwitch: false,
      value: true,
      isChange: false, // 是否由单选转换为多选
      scoreList: [],
      showScore: false,
      totalScore: 0,
      fangdaShow: false,
      fangdaImgUrl: "",
      fangdaTitle: "",
      dataObj: {},
    };
  },
  watch: {
    params: {
      handler(newValue) {
        if (!newValue || Object.keys(newValue).length === 0) return;
        console.log("newValueyyyyyyyyyyyyyy", newValue);
        this.dataObj = newValue;
        this.list = JSON.parse(newValue.chooseList).list;
        this.maxCount = JSON.parse(newValue.chooseList).maxCount
          ? JSON.parse(newValue.chooseList).maxCount
          : 1;
        this.minCout = JSON.parse(newValue.chooseList).minCount
          ? JSON.parse(newValue.chooseList).minCount
          : 1;
        this.isCountMust = JSON.parse(newValue.chooseList).isCountMust;
        this.isCountSwitch = JSON.parse(newValue.chooseList).isCountSwitch;
        this.ifRandomize = newValue.ifRandomize === 1;
        this.isMust = newValue.isMust === 1;
        this.images = JSON.parse(newValue.caseProblemImg);
        this.caseProblem = newValue.caseProblem;
        this.isChange = this.dataObj.isChange;
        this.totalScore = this.list.reduce(
          (acc, cur) => acc + (cur.score || 0),
          0,
        );
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleShowScore() {
      this.scoreList = this.list.map((item, index) => {
        return {
          ...item,
          text: item.text === "" ? "选项" + (index + 1) : item.text,
          score: item.score || 0,
        };
      });
      this.showScore = true;
    },
    handleStepperUpdate(e, index) {
      this.scoreList[index].score = e;
    },
    confirmClick() {
      this.list = this.list.map((item, index) => ({
        ...item,
        score: this.scoreList[index].score,
      }));
      this.totalScore = this.scoreList.reduce(
        (acc, cur) => acc + (cur.score || 0),
        0,
      );
      this.handleUpdate();
      this.showScore = false;
    },
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    handleCaseProblemImg() {
      this.uploadIndex = -1;
      this.$refs.fileInput.click();
    },
    handleItemImage(index) {
      this.uploadIndex = index;
      this.$refs.fileInput.click();
    },

    handleDeleteQuestionImage(index) {
      this.images.splice(index, 1);
      this.handleUpdate();
    },
    handleDeleteItemImage(index, imgIndex) {
      this.list[index].img_path.splice(imgIndex, 1);
      this.handleUpdate();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("file", file); // "file" 对应后端接收的字段名
      formData.append("uuid", this.uuid);
      this.$refs.fileInput.value = "";
      axios
        .post(baseURL + "/PCwj/file/uploads", formData, {
          headers: {
            "Content-Type": "multipart/form-data", // 必须设置
            token: localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.$message.success("上传成功！");
          if (this.uploadIndex === -1) {
            this.images = [response.data.urls];
          } else {
            this.list[this.uploadIndex].img_path = [response.data.urls];
          }
          this.handleUpdate();
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("上传已取消:", error.message);
          } else {
            this.$message.error("上传失败！");
          }
        });
    },
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    addOption() {
      if (this.list.length < 50) {
        this.list.push({
          id: "",
          text: "",
          isChoose: false,
          img_path: [],
          is_fill: 0,
          fill_prompt: "",
          newDate: true,
          score: 0,
        });
        this.handleUpdate();
      } else {
        this.$message.error("最多只能添加50个选项");
      }
    },
    batchAddOptions() {
      this.showpopup = true;
    },
    bitchConfirm(e) {
      this.showpopup = false;
      const count = e.split("\n").filter((item) => item.trim() !== "").length;
      if (count > 50 - this.list.length) {
        this.$message.error("最多只能添加50个选项");
        return;
      }
      const list = e
        .split("\n")
        .filter((item) => item.trim() !== "")
        .map((item) => {
          return {
            id: "",
            text: item,
            isChoose: false,
            img_path: [],
            is_fill: 0,
            fill_prompt: "",
            newDate: true,
            score: 0,
          };
        });
      this.list = this.list.concat(list);
      this.handleUpdate();
    },
    delItem(index) {
      if (this.updateType === 1) {
        if (this.list[index].newDate) {
          this.list.splice(index, 1);
        } else {
          this.$message.error("限制性修改状态下，不能删除之前的数据!");
        }
      } else {
        this.list.splice(index, 1);
      }
      this.handleUpdate();
    },
    handleCountSwitchChange() {
      if (this.isCountSwitch) {
        this.isCountMust = 0;
      }
      this.handleUpdate();
      console.log(
        "888888888888888888888",
        this.isCountMust,
        this.isCountSwitch,
      );
    },
    handleCountMustChange() {
      if (this.isCountMust) {
        this.isCountSwitch = 0;
      }
      this.handleUpdate();
      console.log(
        "999999999999999999999",
        this.isCountMust,
        this.isCountSwitch,
      );
    },
    handleMinCountBlur(e) {
      if (this.minCount === undefined || this.minCount === null) {
        this.minCount = 1;
      }
    },
    handleMaxCountBlur(e) {
      if (this.maxCount === undefined || this.maxCount === null) {
        this.maxCount = this.minCount;
      }
    },
    handleShowCount() {
      console.log("erfewfwefe2112e21");

      this.showCount = true;
    },
    handleCountConfirm(e) {
      this.showCount = false;
      // this.maxCount = e.xCount;
      // this.minCount = e.minCount;
      // this.isCountMust = e.isCountMust;
      // this.isCountSwitch = e.isCountSwitch;
      // this.handleUpdate();
    },
    saveClick() {
      if (this.caseProblem.includes(" ") && this.caseProblem.trim() === "") {
        this.$message.error("请输入题目");
        return;
      }
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        ifRandomize: this.ifRandomize ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem:
          this.caseProblem === "" ? "请从以下选项中选择选项" : this.caseProblem,
        questionScore: this.totalScore,
        chooseList: JSON.stringify({
          list: this.list.map((item, index) => {
            return {
              ...item,
              is_fill: item.is_fill ? 1 : 0,
              text: item.text === "" ? `选项${index + 1}` : item.text,
            };
          }),
          maxCount: this.maxCount,
          minCount: this.minCount,
          isCountMust: this.isCountMust,
          isCountSwitch: this.isCountSwitch,
        }),
      };
      console.log("dataObj", updatedDataObj);
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
    },
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    handleUpdate() {
      const updatedDataObj = {
        ...this.dataObj,
        isMust: this.isMust ? 1 : 0,
        ifRandomize: this.ifRandomize ? 1 : 0,
        caseProblemImg: JSON.stringify(this.images),
        caseProblem: this.caseProblem,
        questionScore: this.totalScore,
        chooseList: JSON.stringify({
          list: this.list.map((item) => {
            return {
              ...item,
              is_fill: item.is_fill ? 1 : 0,
            };
          }),
          maxCount: this.maxCount,
          minCount: this.minCount,
          isCountMust: this.isCountMust,
          isCountSwitch: this.isCountSwitch,
        }),
      };
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: updatedDataObj,
        }),
      );
    },
    showBigImage(img, option) {
      console.log("img", img);
      this.fangdaShow = true;
      this.fangdaImgUrl = img;
      this.fangdaTitle = option.text;
    },
    fangdaClose() {
      this.fangdaShow = false;
      this.fangdaImgUrl = "";
      this.fangdaTitle = "";
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "../QuestionEdit/question-edit-common.scss";

button {
  margin-left: 10px;
}

.clear-btn {
  width: 31px;
  height: 18px;
  background: #ffffff;
  border: 1px solid #3a60ff;
  border-radius: 2px;
  font-size: 11px;
  font-weight: 400;
  text-align: center;
  color: #3a60ff;
  line-height: 18px;
  margin-left: 5px;
  cursor: pointer;
}

.add-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-btn {
  width: 153px;
  height: 32px;
  background: #ffffff;
  border: 1px solid #00c755;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  cursor: pointer;

  span {
    font-size: 14px;
    font-weight: 400;
    color: #00c755;
    margin-left: 11px;
  }
}

.add-batch {
  height: 20px;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: #509dee;
  line-height: 20px;
  cursor: pointer;
}

.del1 {
  width: 19px;
  height: 19px;
  cursor: pointer;
}

.minus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.input {
  padding: 0 10px;
  background: #ffffff;
}

.plus {
  width: 19px;
  height: 19px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.option-item-top-right input {
  color: #4c4a56;
}

.textarea-box {
  ::v-deep .el-textarea__inner {
    color: #4c4a56;
    border: none;
    padding: 0;
    background: transparent;
  }
}

.question-header-left {
  .add-batch {
    margin-left: 10px;
    display: flex;
    align-items: center;
    gap: 5px;

    .icon {
      width: 6px;
      height: 6px;
      border: 1px solid #509dee;
      border-left: none;
      border-bottom: none;
      transform: rotate(45deg);
    }
  }
}

.question-header-right {
  .add-batch {
    border-bottom: 1px solid #509dee;
  }
}

.score-dialog-body {
  max-height: 400px;
  overflow-y: auto;
}

.score-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #e7e7e7;
}

.score-text {
  flex: 1;
  flex-shrink: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  color: #2b2f36;
  margin-right: 10px;
  white-space: normal;
  word-wrap: break;
  word-break: break-all;
  text-align: left;
}

.count-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 15px;
  box-sizing: border-box;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  padding: 15px;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  padding: 20px;
}

.container-gd {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  /* height: 80vh; */
  background: #ffffff;
  border-radius: 8px;
  z-index: 10000000;
  transform: translate(-50%, -50%);
  overflow: hidden;
  overflow-y: auto;
}

.header-div {
  width: 100%;
  height: 59px;
  background-color: #ffffff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 0 14px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
  position: relative;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/EvaluationEdit/EvaluationEditMCQ.vue